import React from "react";
import "./Our_objective.css";
import Common_title from "../../common_components/common-title/Common_title";
import parse from "html-react-parser"
const Our_objective = ({ data }) => {
  return (
    <>
      <section className="Our_Objectives">
        <div className="common_title_div">
          <Common_title title="OBJECTIVES" subtitle="Our Objectives" />
        </div>

        <div className="container">
          <div className="bg_img_holder">
            <img
              src={
                process.env.PUBLIC_URL +
                "/assets/images/about_us/our-objective/vegies.png"
              }
              className="bg_img"
            />

            <div className="content_div">
              <div className="row w-100">
                {data?.map((val) => (
                  <div className="col-sm-6">
                    <div className="white_card">
                      <div className="logo_img_holder">
                        <img
                          src={process.env.REACT_APP_IMG_URL + val?.logo}
                          className="logo_img"
                        />
                      </div>

                      <p className="title">{val?.name}</p>
                      <p className="dsecn">{parse(val?.description)}</p>
                    </div>
                  </div>
                ))}

                {/* <div className='col-sm-6'>
                                    <div className='white_card'>
                                        <div className='logo_img_holder'>
                                            <img src={process.env.PUBLIC_URL + '/assets/images/about_us/our-objective/mission.png'} className='logo_img' />
                                        </div>

                                        <p className='title'>Mission</p>
                                        <p className='dsecn'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                                    </div>
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Our_objective;
